import { render } from "./Upload.vue?vue&type=template&id=64209688&ts=true&lang=pug"
import script from "./Upload.vue?vue&type=script&lang=ts&setup=true"
export * from "./Upload.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__